import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.67618 6.86243C7.74485 6.36805 8.16754 6 8.66667 6H15.3333C15.8325 6 16.2552 6.36805 16.3238 6.86243L17.9905 18.8624C18.0303 19.1489 17.9441 19.4386 17.7542 19.6567C17.5643 19.8748 17.2892 20 17 20H7.00001C6.71079 20 6.43575 19.8748 6.24583 19.6567C6.05591 19.4386 5.96973 19.1489 6.00951 18.8624L7.67618 6.86243ZM9.53738 8L8.14849 18H15.8515L14.4626 8H9.53738Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 19.5C15 20.3284 14.3284 21 13.5 21C12.6716 21 12 20.3284 12 19.5C12 18.6716 12.6716 18 13.5 18C14.3284 18 15 18.6716 15 19.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 5C11.4477 5 11 5.44772 11 6H9.00001C9.00001 4.34315 10.3432 3 12 3C13.6569 3 15 4.34315 15 6H13C13 5.44772 12.5523 5 12 5Z",
			fill: "currentColor"
		})
	]
});
export default SvgNotifications;
